/** The architecture hub: deployment models in tabs, generated views, and the Mermaid source explorer. */
import type { Instruction } from '@crown/framework/ir';
import template from './architecture.tsrx';

const ArchitectureHub: (props: Record<string, never>) => Instruction = template;

export function ArchitectureHubPage(): Instruction {
  return ArchitectureHub({});
}
